var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"c-card-item",class:{ 'c-card-item--border': _vm.border },on:{"click":function($event){$event.stopPropagation();return _vm.$emit('click', _vm.item)}}},[_c('div',{staticClass:"c-card-item--title"},[_vm._v(_vm._s(_vm.title))]),_c('div',{staticClass:"c-card-item--content"},[_vm._t("content")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }